import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentBox" }

import TechnoFrame from "@/components/Common/TechnoFrame.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'ReferralProgramBlockContentHolder',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "401f902d": (`url("/img/page/landing/main/bg/8.webp")`)
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TechnoFrame, {
      offset: 5,
      "size-modifier": 0.3
    }),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"contentHolder\" data-v-e524151e><div class=\"text\" data-v-e524151e><p data-v-e524151e>У нас действует <span class=\"highlighted\" data-v-e524151e>реферальная программа</span>.</p><p data-v-e524151e>После приобретения пропуска ты получишь письмо, в котором найдёшь персональную <span class=\"highlighted\" data-v-e524151e>реферальную ссылку</span>.</p><p data-v-e524151e>Когда кто-нибудь покупает пропуск, используя эту ссылку, он становится твоим рефералом. Ты будешь получать бонусную игровую валюту - <span class=\"gc\" data-v-e524151e>галакоины</span> - за каждого нового реферала. Размер бонуса составляет 25% от суммы галакоинов, обеспечиваемой пропуском реферала.</p><p data-v-e524151e>К примеру, если человек воспользуется твоей ссылкой, чтобы купить пропуск <span class=\"cmb_radiation\" data-v-e524151e>«Реликтовое излучение»</span>, ты получишь <span class=\"gc\" data-v-e524151e>750 галакоинов</span> (то есть 25% от 3000 галакоинов, которые полагаются рефералу за покупку этого пропуска).</p><p data-v-e524151e>А ещё раз в две недели мы разыгрываем дополнительные призы среди тех, по чьей ссылке зарегистрируется больше участников.</p></div></div>", 1))
  ]))
}
}

})